import * as React from "react";

const fields = (t) => ({
  config: { columns: 1 },
  fields: [
    {
      name: "name",
      label: t ? t("common.name") : "Nazwa",
      column: 1,
      mandatory: true
    },
    {
      name: "lineId",
      column: 1,
      type: "unvisible"
    },
  ]
});

export default fields;